import { Injectable } from '@angular/core';

import { MessageService } from 'primeng/components/common/messageservice';
import { LocalStorageService } from 'ng2-webstorage';
import { Observable } from 'rxjs/Rx';

import { AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database-deprecated';
@Injectable()
export class AddUserFirebaseService {
    private schoolId: number;
    public messageId: string;
    public userUrl: string = "/schooluser/";
    constructor(private localStorage: LocalStorageService, private firebasedb: AngularFireDatabase, private messageService: MessageService, ) {
    }



    public postUser(userPayLoad, userId) {
        this.schoolId = this.localStorage.retrieve('SchoolId');
        this.schoolId = this.schoolId;
        var userId = userId;
        this.firebasedb.object(this.schoolId + this.userUrl + userId).set(userPayLoad).then(resolve => {
            this.messageService.add({ severity: 'success', summary: 'Talkative Parents', detail: 'User Added Successfully' });
        }, reject => {
            this.messageService.add({ severity: 'error', summary: 'Talkative Parents', detail: 'Something went Wrong' });
        })
    }
    public getUser(userId): Observable<any> {

        this.schoolId = this.localStorage.retrieve('SchoolId');
        this.schoolId = this.schoolId;
        var userId = userId;
        return this.firebasedb.object(`${this.schoolId + this.userUrl + userId}`).map(items => {
            return items;
            
        });
        
    }

    public deleteUser(userId) {
        this.schoolId = this.localStorage.retrieve('SchoolId');
        this.schoolId=  this.schoolId;
        var userId=userId;
        this.firebasedb.object(this.schoolId +this.userUrl + userId).remove().then(resolve => {
           
        }, reject => {
         
        })

    }
}







// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/components/manageuser/adduser/adduserfirebase.service.ts